module.exports = __webpack_public_path__ + "static/media/recommended.0a01b33d.svg";